









































































































import Vue from 'vue';
import mixin from './vue-file-preview-mixin';

export default Vue.extend({
  mixins: [mixin],
});
